import { ISociometryCondition } from "shared/types/condition";

export const morenoTest: ISociometryCondition = {
    _id: "641b577672dbb9ff0fc7bcb8",
    psychId: "",
    isVisible: false,
    isPublished: false,
    scales: [],
    name: "Социометрия",
    body: {
        conditionId: "641b577672dbb9ff0fc7bcb8",
        name: "Социометрия",
        id: "67a354057237e2819e8012b3",
        desStudents:
            "Ответь, пожалуйста, на приведенные ниже вопросы. Постарайся быть искренним, иначе вся\nработа потеряет смысл. Нам очень хотелось бы знать твое собственное мнение. Обещаем, что\nискренность не обернется тебе во вред.\nЧитай каждый вопрос и сразу отвечай на него. Фамилии указывай в любом порядке.",
        desStudent:
            "Ответь, пожалуйста, на приведенные ниже вопросы. Постарайся быть искренним, иначе вся\nработа потеряет смысл. Нам очень хотелось бы знать твое собственное мнение. Обещаем, что\nискренность не обернется тебе во вред.\nЧитай каждый вопрос и сразу отвечай на него. Фамилии указывай в любом порядке.",
        questions: [
            {
                name: "Если вашу группу (класс) будут расформировывать, с кем бы ты хотел продолжить совместно учиться (работать) в новом коллективе?",
            },
            {
                name: "Если вашу группу (класс) будут расформировывать, с кем бы ты не хотел продолжить совместно учиться (работать) в новом коллективе?",
            },
            { name: "Кого из группы ты бы пригласил на свой день рождения?" },
            { name: "Кого из группы ты бы не пригласил на свой день рождения?" },
            { name: "С кем из своей группы ты пошел бы в многодневный туристический поход?" },
            { name: "С кем из своей группы ты пошел не пошел бы в многодневный туристический поход?" },
        ],
    },
    ages: { min: 10, max: 10 },
    methodAuthor: "Дж. Морено",
    desTeacher: "Описание для учителя",
    desc: "определить социальные связи между детьми (кого не любят, кого любят, кто с кем дружит)",
    directions: [],
    institution: "",
    message:
        "Ответь, пожалуйста, на приведенные ниже вопросы. Постарайся быть искренним, иначе вся работа потеряет смысл. Нам очень хотелось бы знать твое собственное мнение. Обещаем, что искренность не обернется тебе во вред. Читай каждый вопрос и сразу отвечай на него. Фамилии указывай в любом порядке.",
    methodDescription: "определить социальные связи между детьми (кого не любят, кого любят, кто с кем дружит)",
    methodName: "Социометрия",
};
